export default "/_next/static/assets/ClearSans-Medium_762cafcb2d6c44774eea982edca760df.woff2";